import React from "react";

const TODAY_FMT = new Intl.DateTimeFormat("pt-BR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

// Barra do topo: botão do menu lateral (recolhe no desktop, abre a gaveta no celular), breadcrumb
// (grupo / tela) e a data. Branca no desktop, escura no celular (ver .nt-topbar).
export function Topbar({ group, title, onToggleSidebar }: { group: string; title: string; onToggleSidebar: () => void }) {
  return (
    <header className="nt-topbar">
      <button type="button" className="nt-burger" aria-label="Mostrar ou esconder o menu" onClick={onToggleSidebar}>
        <i className="bi bi-list" aria-hidden="true" />
      </button>
      <div className="nt-crumb">
        {group && (
          <>
            <span className="nt-crumb-group">{group}</span>
            <span className="nt-crumb-sep" aria-hidden="true">
              /
            </span>
          </>
        )}
        <strong>{title}</strong>
      </div>
      <span className="nt-today">{TODAY_FMT.format(new Date()).replace(/\./g, "")}</span>
    </header>
  );
}
